import React, { useState, useEffect, useRef } from "react";
import Konn3ctHeader from "../Header & Footer/Konn3ctHeader";
import AI from "../Images/Konn3ct Images/sparkles.png";
import NT from "../Images/Konn3ct Images/note-02.png";
import LB from "../Images/Konn3ct Images/internet-antenna-01.png";
import SD from "../Images/Konn3ct Images/check-list.png";
import smile from "../Images/Konn3ct Images/smile.png";
import polls from "../Images/Konn3ct Images/quiz-03.png";
import support from "../Images/Konn3ct Images/customer-support (1).png";
import dashboard from "../Images/Konn3ct Images/dashboard-speed-02.png";
import Donate from "../Images/Konn3ct Images/gift.png";
import Translate from "../Images/Konn3ct Images/translation.png";
import Caption from "../Images/Konn3ct Images/closed-caption.png";
import eCinema from "../Images/Konn3ct Images/tv-smart.png";
import Doc from "../Images/Konn3ct Images/google-doc.png";
import RM from "../Images/Konn3ct Images/meeting-room.png";
import PB from "../Images/Konn3ct Images/previous.png";
import AB from "../Images/Konn3ct Images/audio-wave-01.png";
import Events from "../Images/Konn3ct Images/calendar-04.png";
import Highlights from "../Images/Konn3ct Images/ai-idea.png";

import FeatP1 from "./Konn3ctF 1";
// import FeatP2 from "./Konn3ctF 2";
import Footer from "../Header & Footer/kfooter";

const FeaturesPage = () => {
  const features = [
    { id: 1, title: "AI", icon: AI },
    { id: 2, title: "Low Bandwidth", icon: LB },
    { id: 3, title: "Meeting Summary", icon: NT },
    { id: 4, title: "Scheduling", icon: SD },
    { id: 5, title: "Reactions", icon: smile },
    { id: 6, title: "Polls", icon: polls },
    { id: 7, title: "Dashboard", icon: dashboard },
    { id: 8, title: "Doc", icon: Doc },
    { id: 9, title: "Audio Boost", icon: AB },
    { id: 10, title: "Playback", icon: PB },
    { id: 11, title: "Rooms", icon: RM },
    { id: 12, title: "Live Caption", icon: Caption },
    { id: 13, title: "Translate", icon: Translate },
    { id: 14, title: "Events", icon: Events },
    { id: 15, title: "eCinema", icon: eCinema },
    { id: 16, title: "Transcriptions", icon: Highlights },
    { id: 17, title: "Donate", icon: Donate },
    { id: 18, title: "24/7 Support", icon: support },
  ];

  const [selected, setSelected] = useState(features[0]);
  const scrollRef = useRef(null);
  const scrollPosRef = useRef(0);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    const autoScroll = () => {
      if (isHovered) return; // pause when hovered

      scrollPosRef.current += 1;

      // Loop when reaching half of the duplicated width
      if (scrollPosRef.current >= scrollContainer.scrollWidth / 2) {
        scrollPosRef.current = 0;
      }

      scrollContainer.scrollLeft = scrollPosRef.current;
    };

    const interval = setInterval(autoScroll, 60);
    return () => clearInterval(interval);
  }, [isHovered]);

  return (
    <div className="relative z-10 min-h-screen w-full text-gray-900 font-sans  overflow-hidden pt-[64px] sm:pt-[80px] md:pt-[100px]">
      <div
        className="absolute inset-0 -z-10"
        style={{
          backgroundImage: `
              repeating-linear-gradient(to right, rgba(128, 128, 128, 0.06) 0, rgba(128, 128, 128, 0.06) 1px, transparent 1px, transparent 100px),
              repeating-linear-gradient(to bottom, rgba(128, 128, 128, 0.06) 0, rgba(128, 128, 128, 0.06) 1px, transparent 1px, transparent 100px)
            `,
        }}
      />
      <Konn3ctHeader />
      {/* ====== Hero Section (with grid) ====== */}
      {/* <section className="relative text-center mt-11 px-6 md:px-12 overflow-hidden"> */}
                  <section className="relative text-center mt-11 px-4 sm:px-6 w-full z-20">
        {/* Grid background for hero only */}
        <h1 className="text-3xl md:text-5xl font-bold text-gray-900 leading-tight mb-4">
          Every feature your team
          <br />
          needs to work faster
        </h1>
        <p className="mt-4 text-base md:text-lg max-w-2xl mx-auto text-gray-700">
          Konn3ct brings together everything your team needs to work smarter and
          faster. From seamless communication and task management to AI-powered
          insights, it keeps projects moving without friction.
        </p>

        <button
          onClick={() =>
            (window.location.href = "https://dashboard.konn3ct.com/register")
          }
          className="px-4 py-2 text-sm text-white bg-[#1A4699] rounded-lg hover:bg-blue-700 transition shadow-sm mt-4"
        >
          Sign up, It’s Free
        </button>

        {/* Auto-scroll Feature Row */}
        <div
          ref={scrollRef}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className="w-full overflow-x-auto hide-scrollbar mt-12"
        >
          <div className="flex gap-4 justify-start px-4 py-4 min-w-max">
            {features.map((item) => (
              <div
                key={item.id}
                onClick={() => setSelected(item)}
                className={`flex flex-col items-center justify-center cursor-pointer rounded-xl w-32 h-32 md:w-36 md:h-36 transition-all duration-300 ${
                  selected.id === item.id
                    ? "bg-blue-50 border-2 border-blue-100 scale-110 shadow-lg"
                    : "bg-white border border-gray-200 hover:shadow-md hover:scale-105"
                }`}
              >
                <img
                  src={item.icon}
                  alt={item.title}
                  className="w-10 h-10 mb-2 object-contain"
                />
                <p
                  className={`font-medium text-sm md:text-base ${
                    selected.id === item.id ? "text-blue-600" : "text-gray-800"
                  }`}
                >
                  {item.title}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ====== Features Details Sections (no grid) ====== */}
      <div className="relative z-20 mt-10 space-y-10">
        <FeatP1 />
        {/* <FeatP2 /> */}
        <Footer />
      </div>
    </div>
  );
};

export default FeaturesPage;
